<template>
  <div>
    <div class="columns">
      <div class="column is-4">
        <r-label
          :red-check="hasCheck"
          :value="f.ref"
          label="Nom"></r-label>
        <div class="control">
          <v-input
            :has-addons="true"
            :id="'funriture_ref' + f.pk"
            :name="'funriture_ref' + f.pk"
            @input="f.ref = $event"
            :model="f.ref"
            :errors-bag="errors"
            v-validate="'required'"
            data-vv-value-path="val"
            data-vv-as="Nom">
          </v-input>
        </div>
      </div>
      <div class="column is-5">
        <r-label
          label="Détails / Informations / N°"
          for="remuneration"
          :value="f.info"
          :is-required="false"></r-label>
        <div class="control is-expanded">
          <v-input
            :has-addons="true"
            :id="'furniture_info' + f.pk"
            :name="'furniture_info' + f.pk"
            @input="f.info = $event"
            :model="f.info"
            :errors-bag="errors"
            data-vv-value-path="val"
            data-vv-as="Infos">
            <p
              class="control"
              slot="addonRight">
              <a
                @click="removeFurniture"
                class="button is-square is-grey is-inverted is-border">
                <span class="icon"><i class="fal fa-trash-alt fa-lg"></i></span>
              </a>
            </p>
          </v-input>
        </div>
      </div>
    </div>
    <div class="deuxieme bloc columns">
      <div class="column is-3">
        <r-label
          label="Prix HT"
          :red-check="hasCheck"
          :value="f.sale_price_ht"></r-label>
        <div class="control">
          <v-input
            :has-addons="true"
            id="sale_price_ht"
            name="sale_price_ht"
            @click="selectedInput = 'ht'"
            @input="updateSalePriceHt($event)"
            :model="roundedValue(f.sale_price_ht)"
            @change="f.sale_price_ht"
            input-type="number"
            v-validate="'required|decimal:2'"
            :errors-bag="errors"
            data-vv-value-path="val"
            :number="true"
            :three-space="true"
            data-vv-as="Prix HT ">
            <p
              v-if="selectedInput === 'ht'"
              class="control"
              slot="addonLeft">
              <a class="button is-square is-static is-border">
                <i class="fal fa-check-circle"></i>
              </a>
            </p>
            <p
              class="control"
              slot="addonRight">
              <a class="button is-static is-border">
                <span class="icon"><i class="fas fa-euro-sign"></i></span><span>HT</span>
              </a>
            </p>
          </v-input>
        </div>
      </div>
      <div class="column is-narrow">
        <r-label
          label="Tva"
          :is-required="false"
          :value="f.tva"
          :truncate="false"></r-label>
        <div class="field is-grouped">
          <div class="control">
            <div class="select">
              <select
                class="has-text-weight-medium"
                v-model.number="f.tva"
                @change="updateTva(f.tva, f.sale_price_ttc, null)">
                <option
                  v-for="(tvaVal, idx) in tvaList"
                  :value="tvaVal"
                  :key="tvaVal + '-' + idx">
                  <span v-if="tvaVal !== 'autre'">{{ tvaVal | tvaLabelRounded }}%</span>
                  <span v-else>{{ tvaVal }}</span>
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <r-label
          label="Prix TTC"
          :red-check="hasCheck"
          :value="f.sale_price_ttc"></r-label>
        <div class="control">
          <v-input
            :has-addons="true"
            id="sale_price_ttc"
            name="sale_price_ttc"
            @click="selectedInput = 'ttc'"
            @input="updateSalePrice($event)"
            :model="roundedValue(f.sale_price_ttc)"
            @change="f.sale_price_ht"
            input-type="number"
            v-validate="'required|decimal:2'"
            :errors-bag="errors"
            data-vv-value-path="val"
            :number="true"
            :three-space="true"
            data-vv-as=" ">
            <p
              v-if="selectedInput === 'ttc'"
              class="control"
              slot="addonLeft">
              <a class="button is-square is-static is-border">
                <i class="fal fa-check-circle"></i>
              </a>
            </p>
            <p
              class="control"
              slot="addonRight">
              <a class="button is-static is-border">
                <span class="icon"><i class="fas fa-euro-sign"></i></span><span>TTC</span>
              </a>
            </p>
          </v-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DefaultValues } from '../../mixins'
import LotMixin from './LotMixin'

export default {
  name: 'AnnexeItem',
  filters: {
    tvaLabelRounded (value) {
      if (value.toString().split('.').length === 1) {
        return `${value}.0`
      } else {
        return value
      }
    }
  },
  mixins: [DefaultValues, LotMixin],
  props: {
    source: {
      type: Object,
      required: true
    },
    defaultFurniture: {
      type: Array
    }
  },
  data () {
    return {
      parkingTypeList: ['Sous-sol', 'Rez-de-chaussée', 'Aérien', 'Extérieur', 'Intérieur', 'Couvert', 'Commandé'],
      tvaList: [20, 'autre']
    }
  },
  computed: {
    tva () {
      return Number((this.f.sale_price_ttc - this.f.sale_price_ht) * 100 / this.f.sale_price_ht).toFixed(2)
    },
    f () {
      return Object.assign(this.source)
    },
    furnitureType () {
      return this.defaultFurniture || []
    }
  },
  methods: {
    removeFurniture () {
      this.$emit('removeFurniture')
    },

    /**
    * update sale price ttc
    * @param {number} valSalePrice
    */
    updateSalePrice (valSalePrice) {
      if (this.f.tva === null) {
        this.f.sale_price_ttc = Number(valSalePrice)
        return this.f.sale_price_ttc
      } else {
        let salePriceTTC, salePriceHT
        if (!this.f.sale_price_ttc || Number(valSalePrice) !== Number(this.f.sale_price_ttc)) {
          salePriceTTC = valSalePrice
          salePriceHT = salePriceTTC / (1 + (this.f.tva / 100))
          salePriceHT = salePriceHT.toFixed(2)
          this.f.sale_price_ht = Number(salePriceHT)
          this.f.sale_price_ttc = Number(salePriceTTC)
        }
      }
    },
    /**
    * update sale price ht
    * @param {number} valSalePriceHt
    */
    updateSalePriceHt (valSalePriceHt) {
      if (this.f.tva === null) {
        this.f.sale_price_ht = Number(valSalePriceHt)
        return this.f.sale_price_ht
      } else {
        let salePriceTTC, salePriceHT
        if (!this.f.sale_price_ht || Number(valSalePriceHt) !== Number(this.f.sale_price_ht)) {
          salePriceHT = valSalePriceHt
          salePriceTTC = salePriceHT * (1 + (this.f.tva / 100))
          salePriceTTC = salePriceTTC.toFixed(2)
          this.f.sale_price_ttc = Number(salePriceTTC)
          this.f.sale_price_ht = Number(salePriceHT)
        }
      }
    },
    updateTva (val) {
      if (val === 20) {
        this.$set(this.f, 'tva', val)
      } else {
        this.$set(this.f, 'tva', null)
      }
    }
  }
}
</script>
